<template>
  <div>
    <EpaymentList
      v-if="islistepayment"
      v-bind:setidoutletsetdeposit="setidoutlet"
      v-on:backtodetail="isdetailsetdeposit"
      v-on:createepaymentt="showcreateepayment"
      v-on:editepayment="showeditepayment"
      ref="listemoney"
    />
    <EpaymentCreate
      v-if="ispaymentcreate"
      v-bind:setidoutletsetdeposit="setidoutlet"
      v-on:backtolist="showlistepayments"
    />
    <EpaymentCreate
      v-if="ispaymentedit"
      v-bind:setidoutletsetdeposit="setidoutlet"
      v-bind:idpayment="datalistepaymentt.idpayment"
      v-on:backtolist="showlistepayments"
    />
  </div>
</template>

<script>
import EpaymentCreate from "../../Epayment/EpaymentCreateV2";
import EpaymentList from "../../Epayment/EpaymentList";

export default {
  name: "SetEpayment",
  components: { EpaymentCreate, EpaymentList },
  props: ["setidoutlet"],
  data() {
    return {
      islistepayment: false,
      ispaymentcreate: false,
      ispaymentedit: false,

      datalistepaymentt: {
        idpayment: "",
      },
    };
  },
  mounted() {
    this.showlistepayment();
    this.loadSettingEpayment();
    var action = this.$route.params.action;
    console.log(this.$route.params)
    switch (action) {
      case "create":
        this.showcreateepayment();
        setTimeout(function() {
          $("#listepayment").hide();
        }, 100);

        break;
      case "edit":
        this.showeditepayment(this.$route.params.id);
        setTimeout(function() {
          $("#listepayment").hide();
        }, 100);

        break;
    }
  },
  methods: {
    showlistepayment() {
      this.islistepayment = true;
      this.ispaymentcreate = false;
      this.ispaymentedit = false;
    },

    showlistepayments() {
      this.islistepayment = true;
      this.ispaymentcreate = false;
      this.ispaymentedit = false;
      $("#listepayment").show();
      this.getlistepayment(true);
    },

    showcreateepayment() {
      this.islistepayment = true;
      this.ispaymentcreate = true;
      this.ispaymentedit = false;
      $("#listepayment").hide();
    },

    showeditepayment(idpayment) {
      this.islistepayment = true;
      this.ispaymentcreate = false;
      this.ispaymentedit = true;
      $("#listepayment").hide();
      this.datalistepaymentt.idpayment = idpayment;
    },

    isdetailsetdeposit() {
      this.$emit("isdetail");
    },

    getlistepayment(refresh = false) {
      this.$refs.listemoney.detailemoney(refresh);
      this.backButtonPressed(this.$refs.listemoney.back);
    },
    async loadSettingEpayment() {
      this.$store.dispatch("pengaturanUmumModule/getSettingEpayment");
    },
  },
};
</script>

<style scoped></style>
